"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dummyReviewStats = exports.dummyPaginatedReviews = exports.dummyReviews = exports.review2 = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _Review = _interopRequireDefault(require("../../records/Review"));

var _ReviewStats = _interopRequireDefault(require("../../records/ReviewStats"));

var _ReviewAxes = require("./ReviewAxes");

var ReviewQuestions = _interopRequireWildcard(require("./ReviewQuestions"));

var _CompanySize = require("./CompanySize");

var _ratings2, _answers2, _ratings3, _answers3, _axes;

var buildDummyReview = function buildDummyReview(_ref) {
  var _ratings, _answers;

  var id = _ref.id,
      createdAt = _ref.createdAt,
      overallRating = _ref.overallRating;
  return _Review.default.from({
    id: id,
    offeringId: 1234,
    userId: 2345,
    portalId: 3456,
    createdAt: createdAt,
    ratings: (_ratings = {}, (0, _defineProperty2.default)(_ratings, _ReviewAxes.ReviewAxes.STARS, overallRating), (0, _defineProperty2.default)(_ratings, _ReviewAxes.ReviewAxes.USABILITY, 4), (0, _defineProperty2.default)(_ratings, _ReviewAxes.ReviewAxes.FUNCTIONALITY, 3), (0, _defineProperty2.default)(_ratings, _ReviewAxes.ReviewAxes.VALUE, 5), (0, _defineProperty2.default)(_ratings, _ReviewAxes.ReviewAxes.SUPPORT_DOCS, 4), _ratings),
    answers: (_answers = {}, (0, _defineProperty2.default)(_answers, ReviewQuestions.TITLE, 'This company is doing it right!'), (0, _defineProperty2.default)(_answers, ReviewQuestions.REVIEW, 'They have really great training materials, both about how to use the product itself and industry best practices. The customer service was very responsive and flexible.'), (0, _defineProperty2.default)(_answers, ReviewQuestions.FOR, 'Generate marketing qualified leads'), (0, _defineProperty2.default)(_answers, ReviewQuestions.CONS, 'It was a little buggy sometimes. There were occasional delays in the sync between Wistia and HubSpot but nothing that stopped us from getting our work done.'), _answers)
  });
};

var dummyData = {
  id: 1,
  displayName: 'Charles Z.',
  industry: 'AVIATION_AEROSPACE',
  employees: _CompanySize.RANGE_1,
  showAvatar: true,
  avatarUrl: 'https://api.hubspotqa.com/hubsettings/v1/avatar/hash/1e6aefa1bbf6250f369c4b89ac7ecf26',
  offeringId: 123,
  userId: 234,
  portalId: 345,
  createdAt: 1578497865211,
  ratings: (_ratings2 = {}, (0, _defineProperty2.default)(_ratings2, _ReviewAxes.ReviewAxes.OVERALL, 4), (0, _defineProperty2.default)(_ratings2, _ReviewAxes.ReviewAxes.USABILITY, 4), (0, _defineProperty2.default)(_ratings2, _ReviewAxes.ReviewAxes.FUNCTIONALITY, 3), (0, _defineProperty2.default)(_ratings2, _ReviewAxes.ReviewAxes.VALUE, 5), (0, _defineProperty2.default)(_ratings2, _ReviewAxes.ReviewAxes.SUPPORT_DOCS, 4), _ratings2),
  answers: (_answers2 = {}, (0, _defineProperty2.default)(_answers2, ReviewQuestions.TITLE, 'This company is doing it right!'), (0, _defineProperty2.default)(_answers2, ReviewQuestions.REVIEW, 'They have really great training materials, both about how to use the product itself and industry best practices. The customer service was very responsive and flexible.'), (0, _defineProperty2.default)(_answers2, ReviewQuestions.FOR, 'Generate marketing qualified leads'), (0, _defineProperty2.default)(_answers2, ReviewQuestions.CONS, 'It was a little buggy sometimes. There were occasional delays in the sync between Wistia and HubSpot but nothing that stopped us from getting our work done.'), _answers2),
  reply: {
    reply: 'Thank you for your kind review! Bacon ipsum dolor amet kielbasa brisket pastrami bacon tenderloin, fatback pork belly hamburger.',
    repliedAt: 1578497875211,
    displayName: 'Charles Z.',
    avatarUrl: 'https://api.hubspotqa.com/hubsettings/v1/avatar/hash/1e6aefa1bbf6250f369c4b89ac7ecf26'
  }
};

var review1 = _Review.default.from(dummyData);

var review2 = _Review.default.from({
  id: 2,
  displayName: 'Kate C.',
  industry: 'ACCOUNTING',
  employees: _CompanySize.RANGE_26_50,
  showAvatar: true,
  avatarUrl: 'https://api.hubspotqa.com/hubsettings/v1/avatar/hash/1e6aefa1bbf6250f369c4b89ac7ecf26',
  offeringId: 1234,
  userId: 2345,
  portalId: 3456,
  createdAt: 1578497885211,
  ratings: (_ratings3 = {}, (0, _defineProperty2.default)(_ratings3, _ReviewAxes.ReviewAxes.OVERALL, 2), (0, _defineProperty2.default)(_ratings3, _ReviewAxes.ReviewAxes.USABILITY, 1), (0, _defineProperty2.default)(_ratings3, _ReviewAxes.ReviewAxes.FUNCTIONALITY, 3), (0, _defineProperty2.default)(_ratings3, _ReviewAxes.ReviewAxes.VALUE, 2), (0, _defineProperty2.default)(_ratings3, _ReviewAxes.ReviewAxes.SUPPORT_DOCS, 1), _ratings3),
  answers: (_answers3 = {}, (0, _defineProperty2.default)(_answers3, ReviewQuestions.TITLE, 'Buyers beware!'), (0, _defineProperty2.default)(_answers3, ReviewQuestions.CONS, "Installing this app destroyed my flywheel. I had to go to the store to get it fixed but they were out of parts. I'm now waiting on a shipment of wooden dowels from Uruguay. My advice: keep your flywheels far far away from this app. Features were decent."), (0, _defineProperty2.default)(_answers3, ReviewQuestions.PROS, 'The myriad of features to help with video marketing tactics are amazing. My favorites were the ability to gate content partway through a video.'), (0, _defineProperty2.default)(_answers3, ReviewQuestions.FOR, "What's my perfect crime? Easy. I break into Tiffany's. Do I go for the vault? No, I go for the chandelier. It's priceless. As I make my exit, someone stops me. Her name is Tiffany. It's her father's business."), (0, _defineProperty2.default)(_answers3, ReviewQuestions.REVIEW, "Low hanging fruit best practices, and we need to make the new version clean and sexy can you ballpark the cost per unit for me. But what's the real problem we're trying to solve here? this medium needs to be more dynamic yet quick win."), _answers3),
  reply: {
    reply: 'Thank you for your kind review! Bacon ipsum dolor amet kielbasa brisket pastrami bacon tenderloin, fatback pork belly hamburger.',
    repliedAt: 1578497875211,
    displayName: 'Charles Z.',
    avatarUrl: 'https://api.hubspotqa.com/hubsettings/v1/avatar/hash/1e6aefa1bbf6250f369c4b89ac7ecf26'
  }
});

exports.review2 = review2;
var dummyReviews = new _immutable.List([review1, review2]);
exports.dummyReviews = dummyReviews;
var fifteenReviewsTemplate = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
var dummyPaginatedReviews = new _immutable.List(fifteenReviewsTemplate.map(function (num) {
  return buildDummyReview({
    id: num,
    createdAt: 100000000000 + num * 100000000000,
    overallRating: num % 5 + 1
  });
}));
exports.dummyPaginatedReviews = dummyPaginatedReviews;

var dummyReviewStats = _ReviewStats.default.from({
  count: 27,
  axes: (_axes = {}, (0, _defineProperty2.default)(_axes, _ReviewAxes.ReviewAxes.OVERALL, {
    count: 27,
    average: 42165,
    distribution: {
      1: 2,
      2: 1,
      3: 4,
      4: 6,
      5: 14
    }
  }), (0, _defineProperty2.default)(_axes, _ReviewAxes.ReviewAxes.USABILITY, {
    count: 27,
    average: 38207,
    distribution: {
      1: 2,
      2: 4,
      3: 7,
      4: 8,
      5: 6
    }
  }), (0, _defineProperty2.default)(_axes, _ReviewAxes.ReviewAxes.FUNCTIONALITY, {
    count: 27,
    average: 16833,
    distribution: {
      1: 10,
      2: 7,
      3: 8,
      4: 2,
      5: 0
    }
  }), (0, _defineProperty2.default)(_axes, _ReviewAxes.ReviewAxes.VALUE, {
    count: 27,
    average: 48999,
    distribution: {
      1: 0,
      2: 0,
      3: 1,
      4: 0,
      5: 26
    }
  }), (0, _defineProperty2.default)(_axes, _ReviewAxes.ReviewAxes.SUPPORT_DOCS, {
    count: 20,
    average: 38475,
    distribution: {
      1: 2,
      2: 0,
      3: 4,
      4: 8,
      5: 6
    }
  }), _axes)
});

exports.dummyReviewStats = dummyReviewStats;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/dummyReviews.js
// module id = 211
// module chunks = 209 210 211 212